var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-container", {
    staticClass: "general-structure"
  }, [_c("el-main", {
    staticClass: "main"
  }, [_c("el-container", [_c("el-dialog", {
    staticClass: "pop-up",
    attrs: {
      visible: _vm.dialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "close-icon",
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_c("i", {
    staticClass: "t-icon x"
  })]), _vm._v(" "), _c("div", {
    staticClass: "scroll"
  }, [_c("clarification-text")], 1)]), _vm._v(" "), _c("el-col", {
    staticClass: "main-area-content",
    attrs: {
      span: 24
    }
  }, [_c("keep-alive", {
    attrs: {
      include: _vm.cachedViews
    }
  }, [_c("router-view")], 1), _vm._v(" "), _c("el-footer", [_c("span", [_vm._v("\n            Telif Hakkı © 2025, İyi Finans - "), _c("span", {
    staticClass: "click",
    on: {
      click: _vm.openKvkkLink
    }
  }, [_vm._v("Müşteri Kişisel Verilerinin İşlenmesi Aydınlatma Metni")])])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };